// extracted by mini-css-extract-plugin
export default {"productGallery":"AO-z","inQuickShop":"BO-z"};